module.exports = __webpack_public_path__ + "img/body.d857fb10.png";